module.exports = require('./helpers/bundle-url').getBundleURL('fI1AJ') + "logo-dark.eefe0b7f.svg";